import { NavLink, Outlet } from "react-router-dom";

const AdminTab = () => {
  return (
    <>
      <nav>
        <NavLink to="/"></NavLink>
        <NavLink to="/home"></NavLink>
        <NavLink to="/create_admin"></NavLink>
        <NavLink to="/delete_user"></NavLink>
        <NavLink to="/invite_church"></NavLink>
        <NavLink to="/dashboard"></NavLink>
        <NavLink to="/invitations"></NavLink>
      </nav>
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default AdminTab;
